














































import './Media.scss'
import { defineComponent } from '@vue/composition-api'
import { AspectRatio } from '../../types'
import { FILE_EXTENSIONS } from '../../data'
import { releaseVideo } from '@/modules/video/utils/VideoManagementUtils'

export default defineComponent({
  name: 'Media',
  props: {
    src: {
      type: String as () => string|null,
      required: false, // when not filled in, create placeholder
      default: null
    },
    alt: {
      type: String,
      required: false,
      default: ''
    },
    caption: {
      type: String as () => string|null,
      required: false,
      default: null
    },
    // isCaptionActive
    // null = trigger hover effect by default | true = caption active, false = caption inactive
    // currently only supporting the hover effect and a forced trigger with isCaptionActive="true"
    // if we want to also disable the hover effect trigger we need to add another class if isCaptionActive="null"
    isCaptionActive: {
      type: Boolean as () => boolean|null,
      required: false,
      default: null
    },
    isPlaying: {
      type: Boolean,
      required: false,
      default: false
    },
    loop: {
      type: Boolean,
      required: false,
      default: false
    },
    muted: {
      type: Boolean,
      required: false,
      default: true
    },
    controls: {
      type: Boolean,
      required: false,
      default: false
    },
    autoplay: {
      type: Boolean,
      required: false,
      default: true
    },
    aspectRatio: {
      type: String as () => AspectRatio,
      required: false,
      default: AspectRatio.Auto
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    showTransparency: {
      type: Boolean,
      required: false,
      default: false
    },
    reloadKey: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data: () => ({
    extensions: FILE_EXTENSIONS,
    videoRef: undefined as HTMLVideoElement|undefined
  }),
  computed: {
    ext (): string {
      const allExts = Object.values(this.extensions).flat()
      const src = this.src?.split('?')[0] ?? ''
      const matchExts = allExts.filter((ext) => src.includes(`.${ ext }`)) ?? []
      return matchExts[matchExts.length - 1] ?? ''
    },
    mediaType (): string {
      if (this.isVideo) return 'video/' + this.ext
      else if (this.isAudio) return 'audio/' + this.ext
      else if (this.isImage) return 'image/' + this.ext
      else return ''
    },
    isPlaceholder (): boolean {
      return this.src === null
    },
    isVideo (): boolean {
      return this.extensions.video.includes(this.ext)
    },
    isAudio (): boolean {
      return this.extensions.audio.includes(this.ext)
    },
    isImage (): boolean {
      return this.extensions.image.includes(this.ext)
    },
    hasSlotCaption (): boolean {
      return !!this.$slots.default
    },
    isLocalSvg (): boolean {
      return (this.src?.startsWith('@/') && this.ext === 'svg') ?? false
    },
    loadedSvg (): any {
      if (this.isLocalSvg) {
        // To render local SVGs, we need to use require to load it as a vue component module.
        // The path to require() needs to be transformed to the correct path inside the webpack. Webpack compiler
        // typically tests the path inside require to pick the correct loader.
        // '@/' and '.svg' hints webpack to use inline loader before giving it to require
        // For more info: https://webpack.js.org/concepts/#loaders
        // NOTE: To render a local PNG, JPG, etc. using Media component, pass return value of
        // require('@/assets/static_file_path.jpg') to Media's src property.
        const relativeFileNameWithoutExt = this.src?.replace('@/', '').replace('.svg', '')
        return require(`@/${relativeFileNameWithoutExt}.svg`)
      } else {
        return null
      }
    }
  },
  watch: {
    isPlaying (newIsPlaying) {
      if (this.isVideo) {
        if (newIsPlaying) this.videoRef?.play()
        else this.videoRef?.pause()
      }
    }
  },
  beforeDestroy () {
    releaseVideo(this.videoRef)
  }
})
